import { render, staticRenderFns } from "./Login-single.vue?vue&type=template&id=4c0c0009&"
import script from "./Login-single.vue?vue&type=script&lang=js&"
export * from "./Login-single.vue?vue&type=script&lang=js&"
import style0 from "./Login-single.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports